function getLanguageFromLangCode(lang) {
    switch (lang) {
        case "en":
            return "ENGLISH";
        case "fr":
            return "FRENCH";
        case "de":
            return "GERMAN";
        case "zh":
            return "CHINESE";
        case "jp":
            return "JAPANESE";
        case "es":
            return "SPANISH";
        case "no":
            return "NORWEGIAN";
        default:
            return "ENGLISH";
    }
}

export { getLanguageFromLangCode };
//# sourceMappingURL=index.js.map
